import { useContext } from 'react'
import firebase from '../firebase/compat'
import { db } from '../firebase/config'
import { SavedIcon } from '../StateManagment/SavedIcon'

/**
 * @typedef {object} ArrayLinkToggle
 * @property {string} collection - Collection of the document that holds the link array
 * @property {string} docid - Firestore docid of that document
 * @property {string} field - Name of the link array (e.g. 'Activity', 'Effect', 'Targetgroup')
 * @property {string} value - The ID to add to or remove from the array
 * @property {boolean} isSelected - Current state as MultiSelect passes it: true → remove, false → add
 */

/**
 * The one write path for the chip link pickers built on `common/MultiSelect`:
 * arrayUnion/arrayRemove one ID, then report the outcome in the snackbar.
 *
 * Nodig omdat elke picker dit zelf deed met alleen een `.then(setSaved)`: een
 * geweigerde of mislukte write liet dan niets zien en de koppeling verscheen
 * gewoon niet. Feedback via de snackbar volgt docs/patterns.md#ui-save-feedback-snackbar
 * (zelfde vorm als useResearchResponseActions).
 * AI-CONTEXT: See docs/pitfalls.md#error-catch-all
 *
 * @returns {(toggle: ArrayLinkToggle) => Promise<void>}
 */
const useArrayLinkToggle = () => {
    const [, setSaved, , setSavedMessage] = useContext(SavedIcon)

    return ({ collection, docid, field, value, isSelected }) => {
        const op = isSelected
            ? firebase.firestore.FieldValue.arrayRemove(value)
            : firebase.firestore.FieldValue.arrayUnion(value)

        return db.collection(collection)
            .doc(docid)
            .update({ [field]: op })
            .then(() => setSaved('flex'))
            .catch((error) => {
                console.error('Koppeling opslaan mislukt', { collection, docid, field, value, isSelected }, error)
                setSavedMessage(isSelected
                    ? 'Loskoppelen is mislukt. De koppeling staat er nog.'
                    : 'Koppelen is mislukt. De koppeling is niet opgeslagen.')
            })
    }
}

export default useArrayLinkToggle
